<div class="ap-slider-wrapper with-input shadow-sm rounded-2">
  <div class="ap-slider-label-wrapper">
    <span>
      {{ filterColumn().label }}
    </span>
  </div>
  <ap-slider
    #slider
    [(ngModel)]="range"
    (onSlideEnd)="updateValue()"
    [sliderId]="filterColumn().key"
    [min]="minValue"
    [max]="maxValue"
    [step]="steps"
    [range]="true"
    [disabled]="isDisabled()"
    [showRange]="true" />
  <div class="ap-slider-header">
    <div class="ap-slider-text">
      <ap-field [hideTitleOnInput]="true" [disabled]="isDisabled()">
        <input
          aria-label="minimum of rangeInputSlider"
          (input)="startChangeHandler($event)"
          (blur)="blurHandler()"
          appkit-field
          [(ngModel)]="range()[0]"
          (keypress)="numberOnly($event)" />
      </ap-field>
      <span class="ap-slider-input-text">to</span>
      <ap-field [hideTitleOnInput]="true" [disabled]="isDisabled()">
        <input
          aria-label="maximum of rangeInputSlider"
          (input)="endChangeHandler($event)"
          (blur)="blurHandler()"
          appkit-field
          [(ngModel)]="range()[1]"
          (keypress)="numberOnly($event)" />
      </ap-field>
    </div>
  </div>
</div>
